export default __webpack_public_path__ + "static/media/ISEO_CLASS-1_SYLLABUS_2025-26.20f2f32e.pdf";